import { COLORS, FONTS } from 'constants/index';

const typography = {
  fontFamily: FONTS,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightHeavy: 700,
  h1: {
    lineHeight: '42px',
    fontSize: '34px',
    fontWeight: 900,
    color: COLORS.BLACK_87
  },
  h2: {
    lineHeight: '24px',
    fontSize: '20px',
    fontWeight: 900,
    letterSpacing: '0.15px',
    color: COLORS.BLACK_87
  },
  h3: {
    lineHeight: '18px',
    fontSize: '16px',
    fontWeight: 'bold',
    letterSpacing: '0.125px',
    color: COLORS.BLACK_87
  },
  h4: {
    lineHeight: '36px',
    fontSize: '30px',
    fontWeight: 500,
    letterSpacing: '-0.46875px',
    color: COLORS.BLACK_DARK
  },
  h5: {
    lineHeight: '25px',
    fontSize: '21px',
    fontWeight: 500,
    textTransform: 'uppercase',
    letterSpacing: '3.61px',
    color: COLORS.GRAY_LIGHT
  },
  subtitle1: { // Note: is up to date
    lineHeight: '16px',
    fontSize: '12px',
    fontWeight: 500,
    letterSpacing: '.4px',
    color: COLORS.BLACK_6
  },
  subtitle2: { // Note: is up to date
    lineHeight: '14px',
    fontSize: '14px',
    fontWeight: 400,
    letterSpacing: '.4px',
    color: COLORS.BLACK_6
  },
  body1: { // Note: is up to date
    lineHeight: '24px',
    fontSize: '16px',
    fontWeight: 400,
    letterSpacing: '0.15px',
    color: COLORS.BLACK_87
  },
  body2: { // Note: this is up to date
    lineHeight: '20px',
    fontSize: '14px',
    fontWeight: 400,
    letterSpacing: '0.25px',
    color: COLORS.BLACK_87
  },
  button: {
    lineHeight: '16px',
    fontSize: '14px',
    fontWeight: 700,
    letterSpacing: '1.25px',
    textAlign: 'center',
    textTransform: 'uppercase',
  },
  overline: {
    lineHeight: '16px',
    fontSize: '10px',
    fontWeight: 500,
    letterSpacing: '1.5px',
    color: COLORS.BLACK_6,
    textTransform: 'uppercase'
  },
};

export default typography;
